import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";

// Components
import IkTable from "@Components/IkTable";

// Utils
import dataHandler from "@Utils/dataHandler";
import { getCallDurationLabel } from "@Utils/formats";

// Styles
import styles from "./styles.module.css";

const Resumidas = ({ dispatch, userName, companyName, onOpenFilterModal, appliedFilters = {} }) => {
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(0);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [sumData, setSumData] = useState({});

	const defaultParams = { page: 1, orderDir: "desc", rows: 20 };
	const [tableParams, setTableParams] = useState(defaultParams);
	const tableFields = "group.name,user.fullName";

	useEffect(() => {
		(async () => {
			try {
				setTableParams(defaultParams);
				const response = await dataHandler({
					dispatch,
					method: "GET",
					url: "/reports/combined/summary/avgTimes",
					params: { ...defaultParams, ...appliedFilters, fields: tableFields },
				});

				setFilteredItems(response.items);
				setFilteredCount(response.count);
				setSumData(response.total);
			} catch (error) {
				setFilteredItems([]);
				setFilteredCount(0);
				setSumData({});
			}
		})();
	}, [appliedFilters]);

	const handlerData = async (params = defaultParams, printable) => {
		if (!printable) {
			setTableParams(params);
		}
		const data = await dataHandler({
			method: "GET",
			dispatch,
			url: "/reports/combined/summary/avgTimes",
			params: { ...params, ...appliedFilters, fields: tableFields },
		});
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
			setSumData(data.total);
		}
	};

	const handleRefreshData = () => {
		setTableParams(defaultParams);
		handlerData({ ...defaultParams, ...appliedFilters });
	};

	const renderTopButtons = () => {
		const hasFilters = Object.keys(appliedFilters || {}).length > 0;
		const filterText = hasFilters ? "Filtrando" : "";

		const buttons = [
			{
				icon: "filter",
				className: hasFilters ? styles.filterButtonActive : styles.filterButton,
				onClick: onOpenFilterModal,
				content: filterText,
				label: filterText,
				showLabel: true,
				componentType: "button",
			},
			{
				icon: "refresh",
				className: styles.refreshButton,
				onClick: handleRefreshData,
			},
		];

		const dateRange = appliedFilters?.createdDate || appliedFilters?.closeDate;
		if (dateRange) {
			const formatDate = (d) => {
				if (!d) return "";
				const parts = d.split("-");
				if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
				return d;
			};
			const [start, end] = dateRange.split(",");
			let value = formatDate(start);
			const today = new Date();
			const currentEnd =
				end || `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
			if (currentEnd && start !== currentEnd) value += ` al ${formatDate(currentEnd)}`;

			buttons.push({
				componentType: "Label",
				title: "Fecha:",
				value,
			});
		}

		return buttons;
	};
	return (
		<div className={styles.container}>
			<div className={styles.containerTableGroup}>
				<div className={styles.tableGroupList}>
					<IkTable
						data={filteredItems}
						columns={[
							{ label: "Grupo", key: "group.name", format: "string", dataPosition: "left", width: 0.5 },
							{ label: "Usuario", key: "user.fullName", format: "string", dataPosition: "left", width: 0.5 },
							{
								label: "Cant. Conver",
								key: "chatCount",
								format: "number",
								dataPosition: "center",
								width: 0.5,
							},
							{
								label: "Cant. Contac.",
								key: "contactCount",
								format: "number",
								dataPosition: "center",
								width: 0.5,
							},
							{
								label: "Cant. Mensaje.",
								key: "messageCount",
								format: "number",
								dataPosition: "center",
								width: 0.5,
							},
							{
								label: "Prom. 1ra Resp",
								key: "avgFirstResponse",
								format: "string",
								dataPosition: "center",
								width: 0.5,
								render: (data) => {
									if (!data.avgFirstResponse || data.avgFirstResponse === 0) return "";
									return getCallDurationLabel(data.avgFirstResponse);
								},
							},
							{
								label: "Prom. Atención",
								key: "avgResponse",
								format: "string",
								dataPosition: "center",
								width: 1,
								render: (data) => {
									if (!data.avgResponse || data.avgResponse === 0) return "";
									return getCallDurationLabel(data.avgResponse);
								},
							},
							{
								label: "Prom. Total",
								key: "avgChatTime",
								format: "string",
								headerPosition: "left",
								dataPosition: "left",
								width: 16,
								render: (data) => {
									if (!data.avgChatTime || data.avgChatTime === 0) return "";
									return getCallDurationLabel(data.avgChatTime);
								},
							},
						]}
						totalRows={filteredCount}
						filteredPrintData={filteredPrintData}
						defaultParams={defaultParams}
						cafParams={{ ...tableParams, ...appliedFilters }}
						dataHandler={handlerData}
						print={{
							printHeader: {
								company: companyName,
								title: "Resumido Grupos/Usuarios",
								user: userName,
							},
						}}
						searcher={{
							searchable: true,
							searchPosition: "flex-start",
							searchDisabled: false,
							filterButton: false,
							width: "40rem",
						}}
						topButtons={renderTopButtons()}
						// handlerMultiple={handlerMultiple}
						sumData={sumData}
						// headerDetail={{ headerTitle: "groupName", dataDetail: "tasks" }} Esta tabla es agrupada que va...
					/>
				</div>
			</div>
		</div>
	);
};

function mapStateToProps({ user, company }) {
	return {
		userName: user.name,
		companyName: company.name,
	};
}

Resumidas.propTypes = {
	companyName: PropTypes.string,
	userName: PropTypes.string,
	dispatch: PropTypes.func,
	onOpenFilterModal: PropTypes.func,
	appliedFilters: PropTypes.object,
};

export default connect(mapStateToProps)(Resumidas);
